// extracted by mini-css-extract-plugin
module.exports = {"talking":"talking-KKftgXIX"};